import { render, staticRenderFns } from "./DerivedAssetsModal.vue?vue&type=template&id=129cd872&"
import script from "./DerivedAssetsModal.vue?vue&type=script&lang=ts&"
export * from "./DerivedAssetsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports